export const SSA_STATUS_POLLING_INTERVAL = 2000;
